import { defineKey as T } from '@ha/intl';

import { TypeValue } from 'ha/types/SearchFilters';
import { ListingKind, ListingType } from 'ha/services/apiV2/types/Listing';

export const PropertyTypeTranslations = {
  HOUSE: T('House'),
  BUILDING: T('Building'),
  APARTMENT: T('Apartment'),
  STUDIO: T('Studio'),
  PRIVATE_ROOM: T('Private room'),
  SHARED_ROOM: T('Shared room'),
};

export const TypesTranslations = {
  [ListingType.House]: T('House'),
  [ListingType.Building]: T('Building'),
  [ListingType.Apartment]: T('Apartment'),
};

export const KindsTranslations = {
  [ListingKind.EntirePlace]: T('Entire place'),
  [ListingKind.PrivateRoom]: T('Private room'),
  [ListingKind.SharedRoom]: T('Shared room'),
};

export const EntirePlaceTypeTranslations = {
  [ListingType.House]: T('Entire house'),
  [ListingType.Building]: T('Entire building'),
  [ListingType.Apartment]: T('Entire apartment'),
};

export const CategoriesTranslations = {
  [TypeValue.PRIVATE_ROOM]: T('Rooms'),
  [TypeValue.SHARED_ROOM]: T('Rooms'),
  [TypeValue.APARTMENT]: T('Apartments'),
  '': T('Accommodation'),
};
